import { AccountingAccount, TaxType } from "../../interface/interface";
import { GetItemsProps, useApiService } from "medere-ui-framework";

type CRUDTaxProps = {
  taxType?: number,
  taxName: string,
  taxValue: number,
  vatTax: boolean,
  isEarningsWithHolding: boolean,
  isIibbWithHolding: boolean,
  forPurchaseInvoices: boolean,
  forSalesInvoices: boolean,
  forPaymentsToOthers: boolean,
  forPaymentsFromOthers: boolean,
  accountingAccount?: AccountingAccount,
  exemptVatTax: boolean,
  vatNotTaxed: boolean
}

export function useTaxService() {
  const { getMethod, postMethod, putMethod } = useApiService();
  const baseEndpoint = "/api/secured/tax";

  function getAllTaxTypes({ offSet, pageSize, params }: GetItemsProps): Promise<TaxType[]> {
    return getMethod<TaxType[]>({
      basePath: baseEndpoint,
      endpoint: "/getAllTaxTypes",
      params: {
        isVatTax: params?.isVatTax,
        offSet,
        pageSize,
        forPurchaseInvoices: params.forPurchaseInvoices ? params.forPurchaseInvoices : null
      }
    }).catch((error) => {
      console.error("Error al obtener impuestos:", error);
      throw error;
    });
  }

  function getAllTaxTypesCombobox({ filterValue, offSet, pageSize, params }: GetItemsProps) {
    return getMethod({
      basePath: baseEndpoint,
      endpoint: "/getAllTaxTypesCombobox",
      params: {
        isVatTax: params.isVatTax,
        inputText: filterValue,
        offSet,
        pageSize,
      }
    });
  }

  function saveTax({ taxName, taxValue, vatTax, isEarningsWithHolding, isIibbWithHolding, forPurchaseInvoices, forSalesInvoices, forPaymentsToOthers, forPaymentsFromOthers, accountingAccount, exemptVatTax, vatNotTaxed }: CRUDTaxProps) {
    return postMethod({
      basePath: baseEndpoint,
      endpoint: "/saveTax",
      body: {
        taxname: taxName,
        taxvalue: taxValue,
        vattax: vatTax,
        isearningswithholding: isEarningsWithHolding,
        isiibbwithholding: isIibbWithHolding,
        forpurchaseinvoices: forPurchaseInvoices,
        forsalesinvoices: forSalesInvoices,
        forpaymentstoothers: forPaymentsToOthers,
        forpaymentsfromothers: forPaymentsFromOthers,
        taxaccount: accountingAccount?.accountingaccount,
        exemptvattax: exemptVatTax,
        vatnottaxed: vatNotTaxed
      }
    });
  }

  function editTax({ taxType, taxName, taxValue, vatTax, isEarningsWithHolding, isIibbWithHolding, forPurchaseInvoices, forSalesInvoices, forPaymentsToOthers, forPaymentsFromOthers, accountingAccount, exemptVatTax, vatNotTaxed }: CRUDTaxProps) {
    return putMethod({
      basePath: baseEndpoint,
      endpoint: "/editTax",
      body: {
        taxtype: taxType,
        taxname: taxName,
        taxvalue: taxValue,
        vattax: vatTax,
        isearningswithholding: isEarningsWithHolding,
        isiibbwithholding: isIibbWithHolding,
        forpurchaseinvoices: forPurchaseInvoices,
        forsalesinvoices: forSalesInvoices,
        forpaymentstoothers: forPaymentsToOthers,
        forpaymentsfromothers: forPaymentsFromOthers,
        taxaccount: accountingAccount?.accountingaccount,
        exemptvattax: exemptVatTax,
        vatnottaxed: vatNotTaxed
      }
    });
  }

  return {
    getAllTaxTypes,
    getAllTaxTypesCombobox,
    saveTax,
    editTax,
  };
}
